import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private requestCount = signal(0);
  
  // Computed signal for loading state
  loading = computed(() => this.requestCount() > 0);

  start(): void {
    this.requestCount.update(count => count + 1);
  }

  stop(): void {
    this.requestCount.update(count => Math.max(0, count - 1));
  }

  // Method to force stop loader (useful for error scenarios)
  forceStop(): void {
    this.requestCount.set(0);
  }
}
